// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__gD8WO","left":"styles_left__3nm88"};